import React from 'react';
import { injectIntl } from 'react-intl';

const PreviewWrapper = (props) => {
	const use_this = props?.use_this ?? true;
	const _class = props?._class ?? '';

	let container_classes = [];
	if(_class != '') container_classes.push(_class);
	
	if(!use_this) {
		return (
			<div class={container_classes.join(" ")}>
				{props.children}
			</div>
		)
	}

	const url = props?.url ?? false;
	const bordered = props?.bordered ?? true;
	const not_bordered = props?.not_bordered ?? false;

	const blocked_styles = {
		minHeight:'100%',
		width:'100%',
	};

	container_classes.push('previewAlike gui_pos_rel without_wrapper');

	let preview_container_class = [
		'preview_container',
		'debug_mode',
		(props?.display_footer_menu ?? false) ? 'with_footer_menu' : 'without_footer_menu',
	];
	if(not_bordered || !bordered) preview_container_class.push('gui_not_bordered');

	return (
		<div class={container_classes.join(" ")}>
			<div class="conts">
				<div class="device_area">
					<div class={preview_container_class.join(" ")}>
						<div class="gui_preview_contents gui_pos_rel" style={blocked_styles}>
							<div class="gui_preview_contents_c" style={blocked_styles}>
								{(url) ? (
									<iframe id="promotion_preview" src={url} />
								) : (
									props.children
								)}
							</div>

						</div>

						<aside id="gui_modal_root_public_entries" class="template_minimal ep_global_contents _wg50 _prop35 pos_cc single_columned wt_bg bl_text awesome" />
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(PreviewWrapper);